import React from "react";
import { useDetectAdBlock } from "../hooks/useDetectAdBlock";
export var AdBlockDetectedWrapper = function AdBlockDetectedWrapper(_ref) {
  var children = _ref.children;
  var adBlockDetected = useDetectAdBlock();
  return React.createElement(React.Fragment, null, adBlockDetected && children);
};